import { queryOptions, useQuery } from '@tanstack/react-query'
import getOtbnAreas, { type OtbnAreasQuery } from '../../services/ruutsApi/getOtbnAreas'
import { queryKeys } from './queryKeys'

export type { OtbnAreasQuery }

// OTBN is provincial forest zoning served through the science API: it changes on legislative
// timescales.
export const OTBN_CACHE_TIME_MS = 2 * 60 * 60_000

export const otbnAreasQueryOptions = ({
  farmId,
  query,
}: {
  farmId: string
  query?: OtbnAreasQuery
}) =>
  queryOptions({
    queryKey: queryKeys.otbnAreas(farmId, query),
    queryFn: ({ signal }) => getOtbnAreas({ farmId, query, signal }),
    staleTime: OTBN_CACHE_TIME_MS,
    gcTime: OTBN_CACHE_TIME_MS,
    refetchOnWindowFocus: ({ state }) => state.status === 'error',
  })

export const useOtbnAreas = ({
  farmId,
  query,
}: {
  farmId: string | undefined
  query?: OtbnAreasQuery
}) => {
  const result = useQuery({
    ...otbnAreasQueryOptions({ farmId: farmId as string, query }),
    enabled: !!farmId,
  })

  return {
    otbnAreas: result.data ?? null,
    isLoading: result.isLoading,
    isError: result.isError,
    error: result.error,
  }
}
